module.exports = __webpack_public_path__ + "img/total.jpg";